import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Formik } from "formik";
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  Grid,
  Switch,
  TextField,
  makeStyles,
  FormControlLabel,
  Divider,
} from "@material-ui/core";

import firebase from '../../Firebase';
import 'firebase/database';
import md5 from 'md5';
import { FormattedMessage, useIntl } from "react-intl";

import { bindActionCreators } from 'redux';
import {
  updateOpenDeviceSearchDialog,
  updateWhichDevice
} from "actions/settings";


import { MAX_LENGTH } from "common/constants";
import { DeviceSearchDialog } from "views/DeviceSearchDailog";
import { DeviceForSleepForm } from "views/DeviceForSleepForm";
import { SIREN_CONFIG, CONFIG_SETTINGS } from 'config.js';


const AuthAddForm = (props) => {
  const { className, history, authInfo, ...rest } = props;
  const classes = useStyles();
  const { formatMessage } = useIntl();

  const [before_md5, setBefore_md5] = React.useState('');
  const [after_md5, setAfter_md5] = React.useState('');

  const selector_selected_devices = useSelector((state) => state.envSettings.selected_device_for_sleep);


  const handleSubmit = (event, values) => {
    event.preventDefault();

    let listDevice = [];

    //redux --> list
    selector_selected_devices.map(item => {
      listDevice.push({
        deviceId: item.deviceId,
        label: item.label
      });
    });

    //NOTE: sleep device default settings하기
    selector_selected_devices.map(item => {

      firebase.database().ref(`/sleep/${item.deviceId}/settings`).get().then((snapshot) =>{
        // console.log('settings:', snapshot.val());
        // console.log('snapshot.val().default_sleep_start_time:', snapshot.val().default_sleep_start_time);
        // console.log('snapshot.val().default_sleep_end_time:', snapshot.val().default_sleep_end_time);

        if(snapshot.val().default_sleep_start_time == null){
          console.log('snapshot.val().default_sleep_start_time is null');
          firebase.database().ref(`/sleep/${item.deviceId}/settings`).update({
            'default_sleep_start_time': "22:30"
          });
        }

        if(snapshot.val().default_sleep_end_time == null){
          console.log('snapshot.val().default_sleep_start_time is null');
          firebase.database().ref(`/sleep/${item.deviceId}/settings`).update({
            'default_sleep_end_time': "06:30"
          });
        }
      });
    });

    firebase.database().ref(`/auth/` + values.auth_id).set({
      auth_id: values.auth_id,
      backend_url: values.backend_url,
      caregiver_id: values.caregiver_id,
      caregiver_name: values.caregiver_name,
      facility_id: values.facility_id,
      facility_name: values.facility_name,
      password: values.password,
      isActive: values.isActive == true ? 1 : 0,
      listDevicesForSleep: listDevice,
      isOnlySleep: values.isOnlySleep == true ? 1 : 0
    }).then(() => {

      //TODO: deviceInfo 변경
      // sleepAnalysis
      // authIdForSleep

      fetch(`${SIREN_CONFIG.HOSTNAME}/device/updateDeviceForSleepAnalysis`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          // facility_id: values.facility_id,
          devices: listDevice,
          sleepAnalysis: 1,
          authIdForSleep: values.auth_id
        }),
      })
        .then((response) => {
          return response.json();
        })
        .then((responseData) => {
          if (responseData.resultCode === "000") {

            alert(formatMessage({ id: 'update_successful' }));

          } else {
            //에러
            console.log(responseData.message);
            alert(`${formatMessage({ id: 'update_failed' })}\n${responseData.resultMessage}\n${responseData.message}`);
          }
        })
        .catch((error) => {
          console.error(error);
          alert(`${formatMessage({ id: 'update_failed' })}\n${responseData.message}`);
        });


      setTimeout(() => {
        history.goBack();
      }, 500);

    })
      .catch((error) => {
        console.error(error);
        alert(formatMessage({ id: 'update_failed' }));
      });

  };


  const handleBack = () => {
    history.goBack();
  };


  const handleChangeMD5 = (event) => {
    setBefore_md5(event.target.value);
  }

  const handleMD5 = () => {
    setAfter_md5(md5(before_md5));
  }


  return (
    <div>

      <DeviceSearchDialog />


      <Formik
        initialValues={{
          auth_id: "",
          backend_url: "",
          caregiver_id: "",
          caregiver_name: "",
          facility_id: "",
          facility_name: "",
          password: "",
          isActive: false,
          isOnlySleep: false, // 수면모니터링 전용 사용자
          // isTargetToSleepAnalysis: false, // 수면 분석 대상 사용자(낙상 사용자 가운데 수면 분석 희망자가 있는 경우를 고려, isOnlySleep=true이면, isTargetToSleepAnalysis은 true)
          sleepDeviceId1: "", //수면모니터링용 센서ID, NOTE: 일단 2개만 등록 가능토록 하자.
          sleepDeviceId2: "", //수면모니터링용 센서ID, NOTE: 일단 2개만 등록 가능토록 하자.
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          isSubmitting,
          touched,
          values,
          setFieldValue,
        }) => (
          <form
            className={clsx(classes.root, className)}
            onSubmit={(e) => handleSubmit(e, values)}
          >
            <Card>

              <CardHeader
                className={classes.card_header}
                title={formatMessage({ id: 'app_login_account_add' })}
                titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h4' }}
              />

              <CardContent>
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.auth_id && errors.auth_id)}
                      fullWidth
                      helperText={touched.auth_id && errors.auth_id}
                      label={formatMessage({ id: 'login_id' })}
                      name="auth_id"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      value={values.auth_id}
                      variant="outlined"
                      inputProps={{ maxLength: MAX_LENGTH.AUTH_ID }}
                    />
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.password && errors.password)}
                      fullWidth
                      helperText={touched.password && errors.password}
                      label={formatMessage({ id: 'password' })}
                      name="password"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      value={values.password}
                      variant="outlined"
                      inputProps={{ maxLength: MAX_LENGTH.CAREGIVER_PASSWORD }}
                    />
                  </Grid>

                  <Grid item md={4} xs={12}></Grid>

                  <Grid item md={4} xs={6}>
                    <TextField
                      error={Boolean(touched.backend_url && errors.backend_url)}
                      fullWidth
                      helperText={touched.backend_url && errors.backend_url}
                      label="backend"
                      name="backend_url"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      value={values.backend_url}
                      variant="outlined"
                      inputProps={{ maxLength: MAX_LENGTH.BACKEND_URL }}
                    />
                  </Grid>

                  <Grid item md={8} xs={12}></Grid>

                  <Grid item md={4} xs={6}>
                    <TextField
                      error={Boolean(touched.facility_id && errors.facility_id)}
                      fullWidth
                      helperText={touched.facility_id && errors.facility_id}
                      label={formatMessage({ id: 'facility_id' })}
                      name="facility_id"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      value={values.facility_id}
                      variant="outlined"
                      inputProps={{ maxLength: MAX_LENGTH.FACILITY_ID }}
                    />
                  </Grid>

                  <Grid item md={4} xs={6}>
                    <TextField
                      error={Boolean(touched.facility_name && errors.facility_name)}
                      fullWidth
                      helperText={touched.facility_name && errors.facility_name}
                      label={formatMessage({ id: 'facility_name' })}
                      name="facility_name"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      value={values.facility_name}
                      variant="outlined"
                      inputProps={{ maxLength: MAX_LENGTH.FACILITY_NAME }}
                    />
                  </Grid>

                  <Grid item md={4} xs={12}></Grid>

                  <Grid item md={4} xs={6}>
                    <TextField
                      error={Boolean(touched.caregiver_id && errors.caregiver_id)}
                      fullWidth
                      helperText={touched.caregiver_id && errors.caregiver_id}
                      label={formatMessage({ id: 'caregiver_id' })}
                      name="caregiver_id"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      value={values.caregiver_id}
                      variant="outlined"
                      inputProps={{ maxLength: MAX_LENGTH.CAREGIVER_ID }}
                    />
                  </Grid>

                  <Grid item md={4} xs={6}>
                    <TextField
                      error={Boolean(touched.caregiver_name && errors.caregiver_name)}
                      fullWidth
                      helperText={touched.caregiver_name && errors.caregiver_name}
                      label={formatMessage({ id: 'caregiver_name' })}
                      name="caregiver_name"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      value={values.caregiver_name}
                      variant="outlined"
                      inputProps={{ maxLength: MAX_LENGTH.CAREGIVER_NAME }}
                    />
                  </Grid>

                  <Grid item md={4} xs={12}></Grid>




                  <Grid container item md={12} xs={12}
                    flexDirection="row"
                    alignItems="stretch"
                    alignContent="center"
                  >

                    <Grid item md={4} xs={6}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={values.isActive}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            color="primary"
                            name="isActive"
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                          />
                        }
                        label={formatMessage({ id: 'activation' })}
                        labelPlacement="end"
                      // variant="outlined"
                      />

                    </Grid>

                    <Grid item md={4} xs={6}>

                      <FormControlLabel
                        control={
                          <Switch
                            checked={values.isOnlySleep}
                            onBlur={handleBlur}
                            // onChange={handleChange}
                            onChange={(e) => {
                              handleChange(e);

                              if (e.target.checked) {
                                setFieldValue('isTargetToSleepAnalysis', true);
                              }

                            }}
                            color="primary"
                            name="isOnlySleep"
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                          />
                        }
                        label={formatMessage({ id: 'isOnlySleep' })}
                        labelPlacement="end"
                      // variant="outlined"
                      />
                    </Grid>

                    {/* <Grid item md={4} xs={6}>

                    <FormControlLabel
                      control={
                        <Switch
                          checked={values.isTargetToSleepAnalysis}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          color="primary"
                          name="isTargetToSleepAnalysis"  //낙상 사용자도 수면 모니터링할 수 있도록 옵션을 제공함.
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        />
                      }
                      label={formatMessage({ id: 'isTargetToSleepAnalysis' })}
                      labelPlacement="end"
                    // variant="outlined"
                    />
                  </Grid> */}

                  </Grid>



                  {/* <Grid item md={8} xs={12}>
                  <TextField
                    error={Boolean(touched.memo && errors.memo)}
                    fullWidth
                    helperText={touched.memo && errors.memo}
                    label="메모"
                    name="memo"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.memo}
                    variant="outlined"
                    inputProps={{ maxLength: 100 }}
                  />
                </Grid> */}

                </Grid>


                <Divider className={classes.divider} variant="inset" />

                <DeviceForSleepForm auth_id={values.auth_id} />

                <Divider className={classes.divider} variant="inset" />


                <Grid container spacing={2}>
                  <Grid item md={3} xs={6}>
                    <TextField
                      fullWidth
                      label={formatMessage({ id: 'before_md5' })}
                      name="before_md5"
                      onChange={handleChangeMD5}
                      value={before_md5}
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item md={2} xs={4}>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleMD5}
                      size="large"
                      className={classes.action}
                    >
                      <FormattedMessage id="conversion" />
                    </Button>
                  </Grid>

                  <Grid item md={3} xs={6}>
                    <TextField
                      fullWidth
                      label={formatMessage({ id: 'after_md5' })}
                      name="after_md5"
                      value={after_md5}
                      variant="outlined"
                      disabled
                    />
                  </Grid>

                </Grid>

                <Divider className={classes.divider} variant="inset" />


                <Grid container className={classes.action}>
                  <Grid item md={8} xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      size="large"
                      disabled={isSubmitting}
                      className={classes.action}
                    >
                      <FormattedMessage id="add" />
                    </Button>

                    <Button
                      variant="outlined"
                      size="large"
                      onClick={handleBack}
                      className={classes.action}
                    >
                      <FormattedMessage id="cancel" />
                    </Button>

                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </form>
        )}
      </Formik>
    </div>
  );
};

AuthAddForm.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
};


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    updateOpenDeviceSearchDialog,
    updateWhichDevice
  }, dispatch);
};

let mapStateToProps = (state) => {
  return {
    settings: state.settings,
    user: state.user
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthAddForm);



const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
    // margin: theme.spacing(2, 0)
  },
  action: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& + &": {
      marginLeft: theme.spacing(1),
    },
  },
  card_header: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  },

  divider: {
    margin: theme.spacing(2, 0)
  },
  dividerInset: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    color: '#616161'
  },
}));

